import {
  IProductFiltersData,
  IFiltersState,
  IFiltersData,
  URLSearchParamsWithSize,
  ILocationInfo,
} from './model';

const getFIltersData = (filters: IProductFiltersData[]): IFiltersData =>
  filters.reduce(
    (allFilters, { properties: { type, options } }) => {
      allFilters.initialState[type] = null;
      allFilters.validTypes.push(type);
      allFilters.validTypeValues[type] = options.map(({ properties: { value } }) => value);
      return allFilters;
    },
    {
      initialState: {},
      validTypes: [],
      validTypeValues: {},
    } as IFiltersData
  );

const hasSelectedFilters = (filters: IFiltersState) => Object.values(filters).some(Boolean);

const updateUrlParams = (pathname: string, searchParams: URLSearchParamsWithSize) => {
  window.history.replaceState(
    {},
    '',
    `${pathname}${searchParams.size ? '?' : ''}${searchParams.toString()}`
  );
};

const getLocationInfo = (): ILocationInfo => {
  const { pathname, search } = window.location;
  return {
    pathname,
    searchParams: new URLSearchParams(search) as URLSearchParamsWithSize,
  };
};

export { getFIltersData, hasSelectedFilters, getLocationInfo, updateUrlParams };
